import { dispatchAnalyticsEvent } from '../components/analytics/analyticsEvents';

export const useAnalytics = (eventName: string, defaultEventData = {}) => {
  return (eventData = {}) => {
    dispatchAnalyticsEvent(eventName, { ...defaultEventData, ...eventData });
  };
};
